import React from "react";
import placeholderImage from "../../../images/placeholder.webp";
import { Skeleton } from "../../Ui/Skeleton/Skeleton";
import ProgressiveImage from "../../Ui/ProgressiveImage/ProgressiveImage";

export const EventCardSkeleton = () => (
  <div className="card elev-sm sp-event-card" style={{ padding: 16 }}>
    <Skeleton height={150} radius="var(--radius-md, 12px)" />
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <Skeleton width={60} height={20} radius={999} />
      <Skeleton width="75%" height={16} />
      <Skeleton width="50%" height={13} />
      <Skeleton width="60%" height={13} />
    </div>
  </div>
);

const formatEventDate = (dateTimeString) => {
  if (!dateTimeString) return "";
  const date = new Date(dateTimeString);
  if (Number.isNaN(date.getTime())) return dateTimeString;
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

const EventCard = ({ event }) => (
  <div className="card elev-sm sp-event-card" style={{ padding: 16 }}>
    <div className="sp-card-media" style={{ height: 150, position: "relative", overflow: "hidden", borderRadius: "var(--radius-md, 12px)" }}>
      <ProgressiveImage
        src={event.images?.[0] || placeholderImage}
        alt={event.title}
        fallbackSrc={placeholderImage}
        loading="lazy"
        fill
        imgClassName="washed"
      />
    </div>
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {event.city && (
        <span className="tag tag-accent" style={{ alignSelf: "flex-start" }}>
          {event.city}
        </span>
      )}
      <div className="card-title">{event.title}</div>
      <div className="card-meta">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.75" strokeLinecap="round">
          <rect x="3" y="5" width="18" height="16" rx="3" />
          <path d="M3 10h18M8 3v4M16 3v4" />
        </svg>
        {formatEventDate(event.dateTime)}
      </div>
      <div className="card-meta">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.75" strokeLinecap="round">
          <path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 12 2.5a7 7 0 0 1 7 7C19 14.8 12 21 12 21Z" />
        </svg>
        {event.location}
      </div>
    </div>
  </div>
);

export default EventCard;
